// extracted by mini-css-extract-plugin
export var clever = "sso-buttons-module--clever--cdbbc";
export var icon = "sso-buttons-module--icon--32c30";
export var root = "sso-buttons-module--root--28ca4";